/**
 * Getters for add appointment module
 */
export const getters = {
  getOverLapCheck(state) {
    return state.overLapCheck;
  },
  getAppointmentSubmitted(state) {
    return state.appointmentSent;
  },
  getAllDay(state) {
    return state.allDay;
  },
  getDate(state) {
    return state.date;
  },
  getStartTime(state) {
    return state.startTime;
  },
  getEndTime(state) {
    return state.endTime;
  },
  getUsePsybooksVideo(state) {
    return state.usePsybooksVideo;
  },
  getUseConnectVideo(state) {
    return state.useConnectVideo;
  },
  getIsOffice(state) {
    return state.isOffice;
  },
  getIsVideo(state) {
    return state.isVideo;
  },
  getIsPhone(state) {
    return state.isPhone;
  },
  getIsOther(state) {
    return state.isOther;
  },
  getStartRepeat(state) {
    return state.startRepeat;
  },
  getEndRepeat(state) {
    return state.endRepeat;
  },
  getOfficeLocation(state) {
    return state.officeLocation;
  },
  getAppointmentType(state) {
    return state.appointmentType;
  },
  getRepeat(state) {
    return state.repeat;
  },
  getNotes(state) {
    return state.notes;
  },
  getEdit(state) {
    return state.edit;
  },
  getIsLoadingAddAppointment(state) {
    return state.loadingAddAppointment;
  },
  getProvider(state) {
    return state.provider;
  },
  getVideoReminder(state) {
    return state.videoReminder;
  },
  getSecondLevelHeaderActive(state) {
    return state.secondLevelHeaderActive;
  },
  getHideBackAndAddButton(state) {
    return state.hideBackAndAddButton;
  }
};
